import { Page } from "@/types/pages";
import routes, { AppRoutes } from "@features/routes";

/**
 * Find a route by its path in the application routes
 * @param pathname - The current pathname to match
 * @returns The matching page route or null if not found
 */
export const findRouteByPath = (pathname: string): Page | null => {
  // Normalize pathname (remove the trailing slash if it's not the root path)
  const normalizedPathname = pathname === "/" ? pathname : pathname.replace(/\/$/, "");

  // Check all feature sections
  for (const featureKey of Object.keys(routes) as Array<keyof AppRoutes>) {
    const feature = routes[featureKey];

    // Check pages in this feature
    for (const pageKey of Object.keys(feature.pages)) {
      const page = (feature.pages as Record<string, Page>)[pageKey];
      // Normalize route path
      const normalizedRoutePath =
        page.pathTemplate === "/" ? page.pathTemplate : page.pathTemplate.replace(/\/$/, "");

      // Check for the exact match first
      if (normalizedRoutePath === normalizedPathname) {
        return page;
      }

      // Check for dynamic path match
      if (normalizedRoutePath.includes("{")) {
        // Convert path template to regex pattern
        // Replace {param} with a regex group that matches any non-slash characters
        const regexPattern = normalizedRoutePath.replace(/{[^}]+}/g, "([^/]+)");
        const pathRegex = new RegExp(`^${regexPattern}$`);

        if (pathRegex.test(normalizedPathname)) {
          return page;
        }
      }
    }
  }

  return null;
};
